"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNursysTransactionUpdateDto = instanceOfNursysTransactionUpdateDto;
exports.NursysTransactionUpdateDtoFromJSON = NursysTransactionUpdateDtoFromJSON;
exports.NursysTransactionUpdateDtoFromJSONTyped = NursysTransactionUpdateDtoFromJSONTyped;
exports.NursysTransactionUpdateDtoToJSON = NursysTransactionUpdateDtoToJSON;
exports.NursysTransactionUpdateDtoToJSONTyped = NursysTransactionUpdateDtoToJSONTyped;
const NursysTransactionStatus_1 = require("./NursysTransactionStatus");
/**
 * Check if a given object implements the NursysTransactionUpdateDto interface.
 */
function instanceOfNursysTransactionUpdateDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('statusMessage' in value) || value['statusMessage'] === undefined)
        return false;
    return true;
}
function NursysTransactionUpdateDtoFromJSON(json) {
    return NursysTransactionUpdateDtoFromJSONTyped(json, false);
}
function NursysTransactionUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, NursysTransactionStatus_1.NursysTransactionStatusFromJSON)(json['status']),
        'statusMessage': json['statusMessage'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}
function NursysTransactionUpdateDtoToJSON(json) {
    return NursysTransactionUpdateDtoToJSONTyped(json, false);
}
function NursysTransactionUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, NursysTransactionStatus_1.NursysTransactionStatusToJSON)(value['status']),
        'statusMessage': value['statusMessage'],
        'data': value['data'],
    };
}
//# sourceMappingURL=NursysTransactionUpdateDto.js.map